import React from "react";
import Navbar from "../components/Navbar";
import backgroundphoto from "../images/kocabay-background.jpeg";
import AboutSection from "../components/AboutSection";
import Services from "../components/ServicesSection";
import SupportBanner from "../components/SupportBanner";
import TransportationServiceSection from "../components/TransportationServiceSection";
import HeroSection from "../components/HeroSection";
import TransportForm from "../components/TransportForm";
import Footer from "../components/Footer";
import Steps from "../components/Steps";
import PolatliTasima from "../components/PolatliTasima";

const Home: React.FC = () => {
  return (
    <div>
      <Navbar />
      <section className="relative w-full h-[500px] sm:h-[600px] flex items-center justify-center text-center text-white">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${backgroundphoto})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-2xl px-6">
          <h1 className="text-3xl sm:text-4xl font-bold mb-4">
          KOCABAY TUR Personel Taşımacılık Hizmeti 
          </h1>
          <p className="text-lg mb-6">
            Kocabay Tur, uzun deneyimiyle taşımacılık, transfer, araç kiralama ve tur organizasyonlarında güvenilir ve profesyonel hizmet sunar.
          </p>
          <a
            href="https://wa.me/905423983273"
            className="bg-[#092049] text-white py-3 px-6 rounded-lg hover:bg-cyan-600 transition"
          >
            Whatsapp Hattı
          </a>
        </div>
      </section>

      {/* Hizmet Özellikleri */}
      <section className="relative -mt-16 py-10">
        <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="bg-white p-6 shadow-2xl rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">7/24 Destek</h3>
            <p>Siz değerli müşterilerimize sürekli hizmet vermek için telefonlarımız açık.</p>
          </div>
          <div className="bg-white p-6 shadow-2xl rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Uygun Fiyatlar</h3>
            <p>Rekabetçi fiyatlar ile sizlere en kaliteli hizmeti verebilmek için çalışıyoruz.</p>
          </div>
          <div className="bg-white p-6 shadow-2xl rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Güvenli Yolculuk</h3>
            <p>Siz değerli müşterilerimizin güvenli yolculuğu için araçlarımızı yeniliyoruz.</p>
          </div>
          <div className="bg-white p-6 shadow-2xl rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Danışma Hattı</h3>
            <p>Bizlere ulaşarak, aklınızdaki tüm sorulara ücretsiz bir şekilde yardımcı oluyoruz</p>
          </div>
        </div>
      </section>
      <AboutSection />
      <Services   />
      <SupportBanner  />
      <TransportationServiceSection />
      <HeroSection />
      <Steps />
      <PolatliTasima />
      <TransportForm />
      <Footer />
    </div>
  );
};

export default Home;
